import { useSelector } from 'react-redux'

import { AttachmentType } from 'utils/types'
import StateType from 'utils/types/states'

const selectAttachments = (state: StateType) => state.attachment.attachments || []

export const useRecordAttachments: () => AttachmentType[] = () => useSelector(selectAttachments)
